module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/SQWknl/tc-custom/9781460317471.jpg?1703390070567",
      "alt": "This image is the cover for the book Reluctant Bachelor"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Reluctant Bachelor\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A SECOND CHANCE AT TRUE LOVE "), _c('br'), _c('br'), _vm._v("Five years ago, Rick Allyn was publicly humiliated  when he had his heart broken on the reality dating show "), _c('i', [_vm._v("True Love.")]), _vm._v(" Convincing him to sign up for another round of punishment isn't going to be easy. But with the show's ratings plummeting, producer Elizabeth Maier will have to persuade him to agreeor she'll be putting in a job application at Rick's small-town diner. "), _c('br'), _c('br'), _vm._v("Elizabeth is confident this season will be different.  With his prominent family, boyish charm and good looks, Rick is the complete package. Finding his soul mate shouldn't be hard. However, as filming continues, she's beginning to suspect that the perfect woman for Rick is "), _c('i', [_vm._v("her.")]), _vm._v(" That leaves Elizabeth with a tough choice: her job at "), _c('i', [_vm._v("True Love")]), _vm._v(" or a shot at the real thing.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Syndi Powell\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Syndi Powell started writing stories when she was young to help her find out what happened after the happily ever after and has made it a lifelong pursuit. She’s been reading Harlequin romance novels since she was in her teens and is thrilled to be a part of their team. She lives near Detroit with her mom who is the first reader of all her books, and two dogs who provide hours of endless entertainment.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0